import React from "react"
import DashboardLayout from "core/layouts/DashboardLayout"
import StandaredSelect from "core/components/StandaredSelect"
import Button from "core/components/new/Button"
import Toast from "core/components/Toast"
import { STR_TEXT_FIELD } from "core/constants/strings"
import ConditionalLoader from "core/components/ConditionalLoader"
import { isEmpty, removeAtIndex } from "core/utils/misc"
import { CrossIcon } from "lucide-react"
import useDatabaseSyncViewModel from "./DatabaseSyncViewModel"
import Table from "core/components/Table"
import SyncedTable from "./components/syncedTable"
import { loader } from "@monaco-editor/react"

export default function DatabaseSyncView() {
  const {
    toast,
    loading,
    collections,
    tableData,
    selectedCollections,
    currentSelectedCollection,
    setSelectedCollections,
    setCurrentSelectedCollection,
    getAllCollections,
    getSyncedDatabaseCollections,
    handleSyncDatabase,
    handleSelectCollection,
    changeToastVisibility,
  } = useDatabaseSyncViewModel()

  React.useEffect(() => {
    getAllCollections()
    getSyncedDatabaseCollections()
  }, [])

  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="w-full">
          <h1 className="text-2xl font-bold leading-[29px] text-new-accent">Database Sync</h1>
          <p className="font-medium">Sync database for all collections or selected collections</p>
        </div>
        <div className="flex justify-center py-12">
          <div className="round-2 flex w-full max-w-xl flex-col items-center p-6 shadow-[0px_4px_16px_rgba(32,76,188,0.2)]">
            <ul className="flex w-full flex-wrap gap-4 border py-2 px-4">
              <ConditionalLoader
                isLoading={isEmpty(selectedCollections)}
                loader={<em className="text-xs text-new-neutral-light">No batches selected</em>}
              >
                {selectedCollections.map((batch: any, i: number) => (
                  <li key={i} className="inline-flex items-center gap-2">
                    {batch}
                    <button
                      className="rounded bg-new-solid-black p-1 text-new-solid-white"
                      onClick={() => {
                        setSelectedCollections(removeAtIndex(selectedCollections, i))
                        setCurrentSelectedCollection("")
                      }}
                    >
                      <CrossIcon className="h-4 w-4" />
                    </button>
                  </li>
                ))}
              </ConditionalLoader>
            </ul>
            <StandaredSelect
              required
              options={collections}
              placeholder="Select Collections"
              onChange={handleSelectCollection}
              value={currentSelectedCollection}
            />
            <Button disabled={loading} loading={loading} className="mt-4" onClick={() => handleSyncDatabase()}>
              {loading ? "Syncing..." : "Sync"}
            </Button>
          </div>
        </div>
        <div className="bg-white relative z-5">
          <div className="space-y-4 pt-[16px] px-6 pb-8 ">
            <div className="space-y-2">
              <h2 className="text-new-accent">Last Synced</h2>
              <p>Last Time the database collection was synced was on</p>
            </div>
            <SyncedTable data={tableData} />
          </div>
        </div>
      </div>
      <Toast data={toast} onClick={() => changeToastVisibility(false)} />
    </DashboardLayout>
  )
}
